export default {
  "meeting": {
    applyrecurring: 'Los cambios se aplicarán al nuevo calendario recurrente. Las reuniones anteriores no se verán afectadas.',
    recurrenceDescribeTwo: 'Se repite cada {loopPulse} semanas los {week}, desde {start} hasta {end}',
    wanttodeletethemeetingfollowTwo: '¿Eliminar la reunión seleccionada y todas las reuniones recurrentes posteriores?',

    loopCycleSelectTips: 'Seleccione el día de la semana en el que desea repetir.',

    export: 'Exportar',
    exportMeetingFileFuncTipsTitle: 'Confirmación de exportación',
    exportMeetingFileFuncTipsContentOne: 'No se aplican filtros. El sistema exportará de forma predeterminada los registros de reuniones del año actual.',
    exportMeetingFileFuncTipsContentTwo: 'Para exportar reuniones de otro período, aplique los filtros correspondientes antes de exportar.',

    myMeetingSearch: 'Mis reuniones',
    meetingTimeSearch: 'Hora de la reunión',
    meetingRoomsSearch: 'Sala de reuniones',

    Recurring: 'Recurrente:',
    wanttodeletethemeetingfollow: '¿Está seguro de que desea eliminar esta reunión y todas las reuniones siguientes?',
    endTimeCannotBeforeBeginTime: 'La fecha de finalización no puede ser anterior a la fecha de inicio',
    Thismeeting: 'Esta reunión',
    Recurringmeeting: 'Reunión recurrente',
    Checkin: 'Registro:',
    checkinTip: 'Después de habilitarlo, los participantes pueden registrarse escaneando el código QR del programador de salas.',
    Recurrence_Setrecurrence: 'Configurar repetición',
    Recurrence_Start: 'Inicio',
    Recurrence_RepeatEvery: 'Repetir cada',
    Recurrence_Week: 'Semana',
    Recurrence_end: 'Fin',
    recurrenceDescribe: 'Ocurre cada {week} desde {start} hasta {end}',
    Recurrence_DoesnotRepeat: 'No repetir',
    Recurrence_Weekly: 'Semanal',

    AddressBookUser: 'Usuario',
    AddressBookPhonebook: 'Libreta de direcciones',

    RoomByPeopleNum1: '2 personas o menos',
    RoomByPeopleNum2: '3-6 personas',
    RoomByPeopleNum3: '7-10 personas',
    RoomByPeopleNum4: '11-15 personas',
    RoomByPeopleNum5: '16-20 personas',
    RoomByPeopleNum6: '21-30 personas',
    RoomByPeopleNum7: 'Más de 30 personas',

    whoAreBound: 'Los usuarios vinculados a una cuenta del sistema verán la reunión en el calendario del sistema. Los usuarios que proporcionen un correo electrónico recibirán notificaciones por correo. Para recibir notificaciones, complete su información en [Mi perfil].',

    AttendessMeeting: 'Asistentes:',
    SelectAttendessMeetingTip: 'Seleccionar asistentes',

    MeetingFilter: 'Filtro de reuniones',
    HostedbyMe: 'Organizado por mí',
    Invitedby: 'Invitado por mí',
    Otherby: 'Otros',

    "AddressIsDuplicated": "El correo del contacto está duplicado",
    "meetingExpired": "Expirado",
    titlePhoneFormat: 'El teléfono solo puede contener números, () + y -.',
    "selectField": "Seleccione un archivo",
    "Limit255": "El nombre del archivo no puede superar los 255 caracteres",
    "nameLimit25": "El nombre no puede superar los 25 caracteres",
    "emailLimit50": "El correo electrónico no puede superar los 50 caracteres",
    "emailFormatError": "Ingrese una dirección de correo válida",
    "phoneLimit11": "El número de teléfono puede tener hasta 11 dígitos",
    "ParticipantsEmail": "Correo del participante:",
    "listIsEmpty": "La lista está vacía",
    "Startimporting": "Comenzar carga",
    "Selectfile": "Seleccionar archivo",
    "Importfile": "Importar archivo",
    "ImportfileTip": "*Solo se admiten archivos CSV en formato Outlook (.csv) o vCard (.vcf) para la importación.",
    "addParticipants": "Agregar participante",
    "multiselectdeselect": "Sugerencia para eliminar etiqueta",
    "multiselectselected": "Sugerencia de selección",
    "enterOrSelectALabel": "Seleccione el correo del participante",
    "deleTitleContact": "¿Seguro que desea eliminar este contacto?",
    "delTitleContactContent": "¿Eliminar contacto?",
    "deleteContactTitle": "Seleccione el contacto que desea eliminar",
    "editcontact": "Editar contacto",
    "Name": "Nombre",
    "email": "Correo",
    "telephoneNumber": "Teléfono",
    "Addcontact": "Agregar contacto",
    "Importcontactfile": "Importar contactos",
    "AddressBook": "Libreta de direcciones",
    "Participants": "Participantes:",

    bindTipContent:"Esta organización ya ha vinculado un calendario de terceros. Programe reuniones a través de Outlook/Teams.",
    Productupdatenews: 'Se ha lanzado una nueva actualización de versión. ',
    bookingPerson: 'Reservado por',
    "DeleteMeeting": "Eliminar reunión",
    "wanttodeletethemeeting": "¿Desea eliminar la reunión?",
    "hasbeendeleted": "La reunión ha sido eliminada",
    "theMeetingWasAborted": "Terminar reunión antes de tiempo",
    "theMeetingWasAbortedContent": "¿Desea terminar la reunión antes de tiempo?",
    "determineTheAbortTask": "Terminar reunión antes de tiempo",
    "theMeetingEndedEarly": "La reunión ha terminado antes de tiempo.",
    "with": "con",
    "Other": "Otro",
    "tasks": "conflicto de tareas",
    "conflict": "El siguiente horario de reunión entra en conflicto:",
    "meetConflicts": "No se pueden seleccionar horarios pasados",
    "itIsNotAllowedToSelectThePastTime": "Seleccionado",
    "selected": "Seleccione no más de 5 salas de reuniones",
    "noOverFive": "Opiniones de aprobación",
    "approvalOpinions": "Fuera del límite de tiempo, no se puede seleccionar",
    "beyondTheTimeLimitItCannotBeSelected": "Mes de inicio",
    "startMonth": "a",
    "to": "Mes de finalización",
    "stopMonth": "Sin inicio",
    "didnTStart": "En curso",
    "ONGOING": "Terminado",
    "ENDED": "ha sido",
    "hasBeen": "reserva",
    "booking": "Aprobación",
    "Approval": "Sala de reuniones",
    "MeetingRoom": "Todas las salas",
    "AllRoom": "Disponible",
    "Available": "Iniciar reunión",
    "Initiate": "Aprobación de la reunión",
    "MeetingApproval": "Mes anterior",
    "PreviousMonth": "Hoy",
    "Today": "Mes siguiente",
    "NextMonth": "Año/Mes",
    "YearMonth": "Mostrar hora",
    "TimeDisplay": "Abreviatura del título de la reunión",
    "MeetingTitleAbbreviation": "Iniciar reunión",
    "InitiateMeeting": "Reuniones próximas",
    "PendingMeetings": "Todas las reuniones",
    "AllMeetings": "No hay reuniones para asistir en este momento",
    "noMeetings": "No iniciado",
    "NotStarted": "Organizador",
    "Organizer": "Fecha y hora",
    "MeetingDateTime": "Ubicación",
    "MeetingLocation": "Asunto de la reunión",
    "MeetingSubject": "Personas invitadas",
    "Invited": "Personas aceptadas",
    "PeopleAccepted": "Editar reunión",
    "EditMeeting": "Cancelar reunión",
    "CancelMeeting": "Iniciar/Editar reunión",
    "InitiateEditMeeting": "Asunto",
    "Subject": "Asunto",
    "Presenter": "Presentador :",
    "DateTime": "Fecha y Hora",
    "TimeAndZone": "Zona horaria",
    "Attendees": "Asistentes",
    "Addrequiredattendees": "Agregar asistentes requeridos",
    "SelectRooms": "Seleccionar salas",
    "Reminder": "Recordatorio",
    "Remindbeforestart": "Recordar antes del inicio",
    "Confirm": "Confirmar",
    "topic": "Asunto :",
    "topicplace": "Nuevo título de la reunión :",
    "speaker": "Presentador :",
    "speakerplace": "Por favor ingrese la información del presentador",
    "DateAndTime": "Fecha y hora :",
    "TimeZone": "Zona horaria",
    "EndDate": "Fecha de fin",
    "Rooms": "Salas :",
    "Notes": "Notas :",
    "MeetingRoomApproval": "Aprobación de la sala de reuniones",
    "PendingApproval": "Pendiente de aprobación",
    "Approved": "Aprobado",
    "nopendingapprovals": "No hay aprobaciones pendientes",
    "Applicant": "Solicitante",
    "UsageTime": "Tiempo de uso",
    "ApprovalResult": "Resultado de la aprobación",
    "ApprovalComments": "Comentarios de la aprobación",
    "Approve": "Aprobar",
    "Reject": "Rechazar",
    "Search": "Buscar",
    "Filter": "Filtrar",
    "scanTheQRCodeToSignIn": "Escanear el código QR para registrarse"
  },
  "NPS": {
    "Relay": "Relé",
    "RelaySettings": "Configuración de Relé",
    "DevicePower": "Control de energía del dispositivo",
    "DeviceElevation": "Control de elevación",
    "LinageWithNPSPower": "Vinculación con energía NPS",
    "PresentationSwitch": "Interruptor de presentación",
    "Duplicate": "Duplicar",
    "LinkagewithNPSPowe": "Vinculación con energía NPS",
    "npsTooltip": "Los dispositivos USB solo pueden ser llamados por un host de PC que esté conectado a HDMI OUT 1.",
    "nmpTooltip": "Haga clic en el botón 'Duplicar' para reflejar el contenido de la pantalla en otras pantallas, sincronizando la visualización en varias pantallas."
  },
  "textTemplate": {
    "template2513": "Difusión de emergencia por incendio",
    "template2514": "Por favor evacúe por la salida de emergencia y la salida de incendios a un lugar seguro de acuerdo con el plan de evacuación contra incendios.",
    "moreTemplate": "Límite de plantilla alcanzado",
    "add": "Añadir",
    "SetTemplate": "Configurar plantilla",
    "Emergency": "Emergencia",
    "General": "General",
    "BroadcastDevices": "Dispositivo de difusión:",
    "selectBroadcastDevices": "Por favor seleccione dispositivos de difusión",
    "All": "Todos",
    "AddTemplate": "Añadir plantilla",
    "EditTemplate": "Editar plantilla",
    "deleteTemplage": "¿Está seguro de que desea eliminar la plantilla seleccionada?",
    "title": "Eliminar plantilla",
    "selectTemplage": "¡Por favor, seleccione una plantilla!",
    "DeleteCancelled": "Eliminación cancelada",
    "DeletedSuccessfully": "¡Eliminado con éxito!",
    "noData": "No se puede usar ninguna plantilla, haga clic en la esquina superior derecha para agregar una plantilla.",
    "TemplateTitle": "Título de la plantilla:",
    "BroadcastType": "Tipo de difusión:",
    "BroadcastTypeDialog": "Tipo de difusión:",
    "selectBroadcastType": "Por favor seleccione el tipo de difusión",
    "BroadcastDuration": "Duración de la difusión:",
    "BroadcastDevice": "Dispositivo de difusión:",
    "BroadcastContent": "Contenido de la difusión:"
  },
  "common": {
    "mediaTimeStateNotifyErrorTitle": "¡Error!",
    "mediaTimeStateNotifyErrorContent": "Su servicio de transmisión ha expirado, por favor contacte a su agente para renovarlo a tiempo.",
    "mediaTimeStateNotifyWarnTitle": "¡Atención!",
    "mediaTimeStateNotifyWarnContent": "Actualmente se encuentra en el estado de prueba, solo puede transmitir y emitir en vivo en 3 dispositivos terminales como máximo.",
    "mediaTimeStateNotifySuccessTitle": "Renovación exitosa",
    "mediaTimeStateNotifySuccessContent": "Su servicio de transmisión está listo para su uso normal. Gracias.",
    "company": "Nombre de la empresa:",
    "tableAddress": "Dirección:",
    "createTime": "Fecha de creación:",
    "email": "Correo electrónico:",
    "phone": "Teléfono:",
    "Trial": "Prueba",
    "TrialWorkstation": "Actualmente se encuentra en el estado de prueba, solo puede transmitir y emitir en vivo en 3 dispositivos terminales como máximo.",
    "Normal": "Normal",
    "NormalWorkstation": "El periodo de validez de su servicio de transmisión es de",
    "to": "a",
    "Advent": "Próximo",
    "AdventWorkstationOne": "Su servicio de transmisión expirará el",
    "AdventWorkstationTwo": ", por favor contacte a su agente para renovarlo a tiempo para su uso normal.",
    "Expired": "Expirado",
    "ExpiredWorkstation": "Su servicio de transmisión ha expirado, por favor contacte a su agente para renovarlo a tiempo."
  },
  "route": {
    "dashboard": "Tablero",
    "i18n": "I18n",
    "Devices": "Dispositivos",
    "Broadcast": "Difusión",
    "Schedule": "Horario",
    "Resources": "Recursos",
    "Live": "En vivo",
    "meetings": "Reunión"
  },
  "navbar": {
    "updates":"Últimas actualizaciones",
    "logOut": "Cerrar sesión",
    "screenfull": "pantalla completa",
    "oprofile": "Mi perfil",
    "settings": "Configuraciones",
    "language": "Idioma",
    "BackTianwa": "Volver a Tianwa",
    "newUserGuide": "Guía para nuevos usuarios"
  },
  "feedback": {
    "Feedback": "Comentarios",
    "email": "Please leave your email for our feedback.",
    "content": "Bienvenido y deje mensajes para mejorar nuestros productos. Gracias por sus comentarios.",
    "submit": "Enviar",
    "emailNoEmpty": "El correo electrónico no puede estar vacío",
    "emailTrueRule": "Por favor ingrese el formato de correo electrónico correcto",
    "contentNoEmpty": "El contenido no puede estar en blanco",
    "feedbackSuccess": "Comentario exitoso",
    "feedbackFailed": "Error al enviar comentario",
    "emailNoChinese": "El correo no puede contener caracteres chinos",
    "emailLength": "Entre 5 y 50 caracteres de longitud",
    "emailSpecialString": "El correo no puede contener cadenas especiales"
  },
  "login": {
    checkPasswordTitleTwo: 'Por favor, establezca una contraseña de al menos 6 caracteres que incluya letras y números. Se permiten caracteres especiales (sin restricciones).',
    captcha: 'Código de verificación',
    checkPasswordTitle: 'La contraseña debe tener al menos 6 caracteres y no puede ser solo números',
    "title": "BIENVENIDO",
    "logIn": "Iniciar sesión",
    "consoleLogin": "Inicio de sesión en la consola",
    "username": "Nombre de usuario",
    "password": "Contraseña",
    "any": "cualquiera",
    "thirdparty": "O conéctese con",
    "thirdpartyTips": "¡No se puede simular de forma local, así que combine con su propia simulación de negocio!",
    "placeholder": ["Nombre de usuario","Contraseña","Código de verificación"],
    "userNameTitle": "¡Nombre de usuario incorrecto!",
    "forget": "¿Lo olvidó?",
    "loginTitle0": "¡Inicio de sesión exitoso!",
    "loginTitle1000": "¡Nombre de usuario o contraseña incorrectos!",
    "loginTitle1001": "¡El nombre de usuario y la contraseña deben ser rellenados!",
    "loginTitle1002": "¡El código de verificación debe ser rellenado!",
    "loginTitle1003": "¡El estado del usuario es ilegal, fallo en el inicio de sesión!",
    "loginTitle1004": "¡Error en el código de verificación!",
    "loginTitle1005": "¡No ha iniciado sesión, por favor inicie sesión primero!",
    "loginTitle1006": "¡Las dos contraseñas son diferentes!",
    "loginTitleUserName": "¡El nombre de usuario debe ser rellenado!",
    "loginTitlePwd": "¡La contraseña debe ser rellenada!",
    "loginTitleVercode": "¡El código de verificación debe ser rellenado!",
    "titleLoginNameFormat": "La cuenta debe consistir en caracteres, o caracteres y números.",
    "privacy": "Q-NEX User Privacy Policy",
    "privacyContent": "Agree to",
    "_zh": "中文(简体)",
    "_en": "_English",
    "_ko": "한국어",
    "_zh_ft": "中文(繁體)"
  },
  "home": {
    "btnDevices": "Dispositivos",
    "btnRoadcast": "Transmisión",
    "btnResources": "Recursos",
    "btnLive": "En vivo",
    "meetings": "Reunión",
    "todaySchedule": "Horario de hoy",
    "allSkedules": "Todos los horarios",
    "details": "Detalles",
    "btnStart": "Iniciar",
    "titleContent": "¡Saludos! ¡La consola Q-NEX está a su servicio! ¡Comencemos!",
    "btnExit": "Salir"
  },
  "devices": {
    ptzCamera:'Cámara PTZ',
    "start": "INICIAR",
    "stop": "DETENER",
    "nmpPowerOff_mandatory": "En transmisión (no obligatoria)",
    "nmpPowerOff_nomandatory": "En transmisión (no obligatoria). ¿Continuar ejecución?",
    "nmpsPowerOff_mandatory": "Algunos NMP están en transmisión (obligatoria).",
    "nmpsPowerOff_nomandatory": "Algunos NMP están en transmisión (no obligatoria). ¿Continuar ejecución?",
    "reset": "Restablecer",
    "displayedInTheControlArea": "Mostrado en el centro de control",
    "dragOrder": "Arrastrar orden",
    "areaSettingTwoNotice": "*El control RS232, AC y control remoto se muestran en el centro de control según el estado de vinculación NMP en el panel de control.",
    "areaSettingThreeNotice": "*El control CBX se muestra en el centro de control según el estado de vinculación NMP en el panel de control.",
    "controlSet": "Configuración del centro de control",
    "vcbNoLine": "No hay dispositivos CBX en línea",
    "vcbNoBound": "No hay dispositivos CBX vinculados",
    "tscNoBound": "RS232 en TSC no está vinculado a ningún dato. Por favor, avise al administrador para vincularlo en el panel de control.",
    "light": "Control de energía",
    "vcbpower": "Energía",
    "rs232Control": "Control Serial",

    "CBX": {
    "powerSupplyON": "Encender",
    "powerSupplyOFF": "Apagar",
    "lockScreenON": "Bloquear",
    "lockScreenOFF": "Desbloquear",
    "childLockON": "Bloqueo infantil activado",
    "childLockOFF": "Bloqueo infantil desactivado",
    "energySavingON": "Ahorro de energía activado",
    "energySavingOFF": "Ahorro de energía desactivado",
    "signalSourceSwitchingON": "OPS",
    "signalSourceSwitchingOFF": "Android",
    "volumeAdjustment": "Altavoz",
    "brightAdjustment": "Brillo",
    "other": "Otras características..."
    },

    "InterfaceOne": "Interfaz Uno",
    "InterfaceTwo": "Interfaz Dos",
    "abcStyleP": "¡Lo siento! TSC y (NMP, MBX, NPS, NDP100, NDP500) no pueden ser seleccionados al mismo tiempo",
    "masterControl": "principal",
    "powerSupply": "Poder",
    "RecordingControl": "Control de grabación",
    "RecordingControlSystem": "Sistema de captura de conferencias",
    "LiquidCrystal": "Pantalla LCD interactiva",
    "projector": "Proyector",
    "othertype": "Otro",
    "lockScreen": "Bloqueo",
    "childLock": "Bloqueo infantil",
    "energySaving": "Ahorro de energía",
    "signalSourceSwitching": "Fuente de entrada",
    "volumeAdjustment": "Altavoz",
    "brightAdjustment": "Brillo",
    "other": "Otras características",
    "otherFunction": "Función",
    "send": "Enviar",
    "ON": "ON",
    "OFF": "OFF",
    "_POWERA": "Display Power",
    "_POWERB": "External Power",
    "_MAGNETICLOCK": "MAGNETICLOCK",
    "_HDMI1": "HDMI in 1",
    "_HDMI2": "HDMI in 2",
    "_HDMI3": "HDMI in 3",
    "_HDMIA": "HDMI out A",
    "_HDMIB": "HDMI out B",
    "_HDMIC": "HDMI out C",
    "_AIR": "Aire acondicionado",
    "titleDevices": "Filtro de grupos:",
    "content": "Buscar",
    "selectALL": "Seleccionar TODO",
    "SelectRecentPage": "Seleccionar la página actual",
    "controlPanel": "Centro de control",
    "displayInputSwitch": "Conmutador de entrada de pantalla",
    "chooseINPUTSources": "Elegir fuentes de ENTRADA",
    "speakerVolume": "Volumen de audio",
    "bass": "Bajos",
    "treble": "Agudos",
    "MICVolume": "Volumen MIC",
    "AirConditioning": "Aire acondicionado",
    "model": "Modelo",
    "setTemp": "Temperatura ajustada",
    "fanSpeed": "Velocidad del ventilador",
    "bold": "Oscilación",
    "projectionScreen": "Pantalla de proyección",
    "electronicLock": "Cerradura eléctrica",
    "electronicLock1": "Cerradura eléctrica",
    "selectDevices": "Por favor, seleccione un dispositivo o un grupo de dispositivos",
    "isCompelType": "El control del dispositivo no está disponible debido a la transmisión obligatoria, intente nuevamente más tarde.",
    "mainPower": "Poder principal",
    "extraPower": "Poder extra",
    "power": "Poder",
    "hdmiBroadcast": "Difusión",
    "equipmentState1": "Encender",
    "equipmentState2": "Apagar",
    "equipmentState3": "Desconectado",
    "main": "Principal",
    "external": "Externo",
    "ProjectionScreen": "Pantalla de proyección",
    "UP": "SUBIR",
    "DOWN": "BAJAR",
    "LOCK": "BLOQUEAR",
    "UNLOCK": "DESBLOQUEAR",
    "PleaseDevice": "Por favor, seleccione el o los dispositivos a la izquierda",
    "RemoteControl": "Control remoto",
    "Action": "Acción",
    "Devicefilter": "Filtro de dispositivo",
    "DeviceStatus": "Estado",
    "DeviceType": "Tipo",
    "currentAudioSource": "Fuente de audio actual",
    "audioSwitching": "Interruptor de salida de audio"
  },
  "broadcast": {
    "isBoarding": "(En emisión)",
    "last3Days": "ÚLTIMOS 3 DÍAS",
    "last7Days": "ÚLTIMOS 7 DÍAS",
    "last30Days": "ÚLTIMOS 30 DÍAS",
    "historyRecord": "Historial",
    "SelectDestination": "1.Seleccionar destino",
    "BroadcastingConsole": "2.Consola de emisión",
    "Notification": "Notificación",
    "btnStop": "Detener",
    "btnStart": "Iniciar",
    "Letters60": "(menos de 60 caracteres)",
    "Letters300": "(menos de 300 caracteres)",
    "LastingTime": "Duración:",
    "Title": "Título:",
    "Content": "Contenido:",
    "Cannotquit": "Emisión obligatoria",
    "ChooseMedia": "Seleccionar un archivo multimedia",
    "Broadcasting": "Emisión",
    "dialogTitle": "Recursos de video y audio",
    "SortBy": "Ordenar por",
    "btnBake": "Volver al anterior",
    "cancel": "Cancelar",
    "confirm": "Confirmar",
    "save": "Guardar",
    "coxAll": "Todo",
    "PublicCloud": "Almacenamiento público",
    "IndividualCloud": "Almacenamiento personal",
    "selFile": "Por favor seleccione un archivo o un grupo.",
    "StopBroadcast": "Detener emisión",
    "StartBroadcasting": "Iniciar emisión",
    "StopBroadcasting": "Detener emisión",
    "ForceQuit": "Forzar cierre",
    "PleaseMediaFile": "Por favor seleccione un archivo multimedia",
    "PleaseDevice": "Por favor seleccione un dispositivo",
    "broadcast_0": "Iniciar emisión",
    "broadcast_2500": "Excede el número máximo de dispositivos conectables para el servidor multimedia",
    "broadcast_2501": "Error de archivo de emisión",
    "broadcast_2502": "Emisión terminada",
    "broadcast_2503": "No se pudo obtener información del servidor multimedia",
    "broadcast_2510": "¡Atención! Actualmente está en estado de prueba, hasta 3 dispositivos terminales pueden recibir comandos de transmisión. Verifique la cantidad de dispositivos que ha seleccionado.",
    "broadcast_2018": "El servicio de transmisión está apagado.",
    "broadcast_2019": "El servicio de transmisión ha expirado.",
    "broadcast_2512": "Exceso del límite de cantidad de plantillas.",
    "broadcast_2513": "Difusión de emergencia por incendio.",
    "broadcast_2514": "Por favor evacue a un lugar seguro desde la salida de emergencia y la salida de incendios según el plan de escape.",
    "broadcast_2006": "Dispositivo no encontrado.",
    "broadcast_2": "El servicio de disco es anormal.",
    "broadcast_2515": "Seleccione un dispositivo que no tenga capacidades de transmisión.",
    "broadcast_2516": "Seleccione archivos que superen la resolución máxima compatible con NMP.",
    "broadcast_2517": "Seleccione archivos que superen la resolución máxima compatible con NDP500.",
    "broadcast_Title": "Alerta de transmisión.",
    "broadcast_TitleNDP500": "Alerta de transmisión NDP500.",
    "broadcast_content": "El dispositivo admite hasta 4K@30FPS, con una resolución óptima de 1080P@30FPS.",
    "broadcast_contentNDP500": "NDP500/600 admite hasta 1080P@30FPS, con una resolución óptima de 720P@30FPS.",
    "broadcast_noSupported": "Los siguientes videos seleccionados no son compatibles para la transmisión:",
    "broadcast_noSupportedNDP500": "Los siguientes videos seleccionados no son compatibles para la transmisión en NDP500/600:"
  },
  "resources": {
    "uploadNameLengthError": "¡El nombre del archivo subido no puede exceder las 100 palabras!",
    "onUploadFile": "No hay archivos para subir",
    "open": "Abrir",
    "fold": "Plegar",
    "close": "Cerrar",
    "PublicCloud": "Almacenamiento público",
    "IndividualCloud": "Almacenamiento personal",
    "TransfersHistory": "Historial de transferencias",
    "btnDownload": "Descargar",
    "btnDelete": "Eliminar",
    "btnUploadFile": "Subir archivo",
    "btnNewFolder": "Nueva carpeta",
    "btnBake": "Volver a la anterior",
    "coxAll": "Todo",
    "uploadError": "¡El tamaño del archivo subido no puede exceder 1 GB!",
    "MD5": "Verificar MD5",
    "merge": "Fusionando",
    "transcoding": "Transcodificación",
    "uploadFailed": "Fallo en la subida",
    "fileError": "Error de lectura del archivo, por favor revisa el archivo.",
    "tableName": "Nombre",
    "tableSize": "Tamaño",
    "tableType": "Tipo",
    "tableTimeAdded": "Hora de adición",
    "tableAction": "Acción",
    "btnRename": "Renombrar",
    "btnMoveTo": "Mover a...",
    "ClearAll": "Limpiar todo",
    "cancel": "Cancelar",
    "confirm": "Confirmar",
    "save": "Guardar",
    "addSuccess": "¡Añadido con éxito!",
    "addError": "¡Fallo al añadir!",
    "editSuccess": "¡Editado con éxito!",
    "editError": "¡Fallo al editar!",
    "delSuccess": "¡Eliminación exitosa!",
    "delError": "¡Error al eliminar!",
    "diskError3000": "¡Se ha superado el tamaño total del espacio, la operación falló!",
    "diskError3001": "¡Se ha superado el espacio público utilizado, la operación falló!",
    "diskError3002": "¡Se ha superado el espacio personal utilizado, la operación falló!",
    "diskError3003": "¡No se pueden encontrar los datos, por favor verifique si el servidor multimedia está vinculado!",
    "diskError3004": "¡El nombre de la carpeta ya existe!",
    "diskError3005": "¡Error al obtener la carpeta!",
    "diskError3006": "¡No se pueden crear más de 99 carpetas al mismo nivel!",
    "diskError3007": "¡El mismo nombre de archivo existe y la modificación falló!",
    "diskError3008": "¡El mismo nombre de carpeta existe y la modificación falló!",
    "diskError3009": "¡El archivo excede el espacio restante y la carga falló!",
    "diskError3010": "¡Error al cargar!",
    "diskError3011": "¡Error en la verificación del archivo, por favor vuelva a cargar el archivo!",
    "diskError3012": "¡Error al obtener la dirección del servicio en la nube privada, la operación falló!",
    "diskError3013": "¡Las combinaciones de archivos múltiples no deben exceder los 100 MB, los archivos grandes deben descargarse por separado!",
    "diskError3014": "¡Error de compresión, por favor seleccione de nuevo el archivo para descargar!",
    "diskError3015": "¡Necesita permiso para realizar esta acción!",
    "downloadError": "¡Error al descargar!",
    "mobileError": "¡Error al mover!",
    "root": "Todos los archivos",
    "Name": "Nombre",
    "Size": "Tamaño",
    "Type": "Tipo",
    "uploadFile": "Subir archivo",
    "newFolder": "Nueva carpeta",
    "tableTime": "Tiempo",
    "permission": "¡Permisos insuficientes!",
    "notifyTitle": "Notificación",
    "notifyContent": "¡El usuario no tiene permisos suficientes para acceder!",
    "sortFileName": "Nombre del archivo",
    "sortTime": "Tiempo",
    "sortSize": "Tamaño",
    "sortType": "Tipo",
    "moveTo": "Mover a",
    "test": "Nuevo",
    "delTitle": "¿Eliminar?",
    "delTitleContent": "El contenido seleccionado se eliminará de la base de datos. La operación no puede deshacerse. ¿Está seguro de que desea continuar?",
    "delCancelButton": "Cancelar",
    "delConfirmButton": "Confirmar"
  },
  "userMge": {
    "userName": "Nombre de usuario:",
    "jobNumber": "ID de empleado:",
    "email": "Correo electrónico:",
    "phone": "Teléfono:",
    "group": "Grupo:",
    "oldPassword": "Contraseña antigua:",
    "newPassword": "Nueva contraseña:",
    "confirmNewPassword": "Confirmar nueva contraseña:",
    "btnSave": "Guardar cambios",
    "titleChangePassword": "Cambiar contraseña",
    "titleMyProfile": "Mi perfil",
    "name": "Apodo:",
    "error1400": "¡La cuenta (personalizada) ya existe, la operación falló!",
    "error1401": "¡La cuenta (generada por el sistema) ya existe, la operación falló!",
    "error1402": "¡El grupo no existe, la importación falló!",
    "error1403": "Error de datos",
    "error1404": "Permisos insuficientes",
    "selUser": "¡Por favor seleccione un usuario!",
    "error1405": "¡Error al obtener el rol!",
    "error1406": "El formato de los datos de la información de usuario importada es incorrecto",
    "error1407": "El correo electrónico ya existe y la operación falló.",
    "error1408": "El teléfono ya existe y la operación falló.",
    "editSuccess": "¡Guardado con éxito!",
    "ChangePassword": "Cambiar contraseña",
    "UserPrivacyAgreement": "Política de privacidad del usuario"
  },
  "information": {
    "_2602": "Dispositivo fuera de línea",
    "_2603": "Error de transmisión",
    "_2604": "La transmisión ha sido cortada",
    "_2605": "El espacio de almacenamiento está lleno",
    "_2606": "hace unos minutos",
    "_2607": "hace unas horas",
    "_2609": "error, por favor ",
    "_2609_a": "haga clic aquí ",
    "_2609_time": "para tratarlo a tiempo",
    "userType": "Administrador",
    "unreadNoticeFirst": "Leer primero las notificaciones",
    "sortByTime": "Ordenar por tiempo",
    "coxRead_1": "Leído",
    "coxRead_0": "No leído",
    "allCoxRead": "Marcar todo como leído",
    "load": "Cargando...",
    "noData": "No hay más datos",
    "viewALLMessages": "Ver TODAS las notificaciones"
  },
  "input": {
    "select": "Por favor seleccione",
    "thisField": "Este campo debe ser completado.",
    "titleShooleNub60": "menos de 60 caracteres",
    "titleShooleNub300": "menos de 300 caracteres",
    "Offline": "Desconectado"
  },
  "schedule": {
    "OnlyManual": "Solo Manual",
    "runStartNow": "Ejecutar tarea",
    "runStopNow": "Detener tarea",
    "tackExecutionStart": "Tarea en ejecución",
    "tackExecutionStop": "Ejecución de tarea detenida",
    "dehumidification": "Deshumidificación",
    "airSupply": "Suministro de aire",
    "masterControl": "principal:",
    "powerSupply": "Energía",
    "lockScreen": "Bloqueo",
    "RecordingControl": "Control de grabación",
    "RecordingControlSystem": "Sistema de captura de conferencias",
    "LiquidCrystal": "Pantalla LCD interactiva",
    "projector": "Proyector",
    "othertype": "Otro",
    "childLock": "Bloqueo infantil",
    "energySaving": "Ahorro de energía",
    "signalSourceSwitching": "Fuente de entrada",
    "other": "Otras funciones:",
    "otherFunction": "Función",
    "send": "Enviar",
    "ON": "ENCENDIDO",
    "OFF": "APAGADO",
    "btnAddSchedule": "Restaurar",
    "EditSchedulelist": "Editar programador",
    "AddSchedulelist": "Agregar programador",
    "RestoreSchedulelist": "Restaurar",
    "btn": "Cancelar",
    "btnNewList": "Nuevo programador",
    "ListName": "Nombre",
    "Cannotquit": "Obligatorio",
    "NOCannotquit": "NO",
    "ListValidityPeriod": "Período de validez",
    "ListDescription": "Descripción",
    "currentSchedule": "Lista de programadores",
    "historySchedule": "Lista de historial",
    "selectTime": "Hora",
    "selectTimeTable": "Hora",
    "taskType": "Tipo de tarea",
    "selectBroadcasting": "Difusión",
    "selectDeviveControl": "Control de dispositivo",
    "newSchedule": "Nueva tarea",
    "newChecklist": "Nueva lista de verificación",
    "titleStatus": "Estado",
    "titleType": "Tipo",
    "titleStartTime": "Hora de inicio",
    "titleEndTime": "Hora de finalización",
    "titleRepeat": "Repetir",
    "titleName": "Nombre",
    "titleAction": "Acción",
    "tableEnabled": "Habilitado",
    "tablePaused": "Pausado",
    "tableEdit": "Editar",
    "tableDelete": "Eliminar",
    "tableVolumeEdit": "Volumen de difusión",
    "tableBroadcastTitle": "Título",
    "tableBroadcastContent": "Contenido",
    "tableBroadcastList": "Lista",
    "tableBroadcast": "Obligatorio",
    "btnRemoveCompletely": "Eliminar completamente",
    "btnEnabled": "Tarea habilitada",
    "btnPaused": "Deshabilitar tarea",
    "btnDelete": "Eliminar",
    "repeat0": "LUN",
    "repeat1": "MAR",
    "repeat2": "MIÉ",
    "repeat3": "JUE",
    "repeat4": "VIE",
    "repeat5": "SÁB",
    "repeat6": "DOM",
    "dialogTitleAdd": "Nueva tarea de control de dispositivos",
    "dialogTitleEdit": "Editar tarea de control de dispositivos",
    "newBroadcastingSchedule": "Nueva tarea de transmisión",
    "editBroadcastingSchedule": "Editar tarea de transmisión",
    "chooseDevice": "Seleccionar dispositivo",
    "timeSetting": "Ajuste de hora",
    "controlBroadcasting": "Opción de transmisión",
    "controlOption": "Opción de control",
    "scheduleName": "Nombre de la tarea:",
    "destination": "Destino",
    "timeTilte": "Hora",
    "repeatTitle": "Repetir",
    "dialogRepeat0": "LUN",
    "dialogRepeat1": "MAR",
    "dialogRepeat2": "MIÉ",
    "dialogRepeat3": "JUE",
    "dialogRepeat4": "VIE",
    "dialogRepeat5": "SÁB",
    "dialogRepeat6": "DOM",
    "dialogOnceType": "Una vez",
    "dialogRepeatType": "Repetir",
    "Manual": "Manual",
    "ManualContent": "Puedes ejecutar estas tareas manualmente una vez que termines la configuración.",
    "mainPower": "Energía principal",
    "powerControl": "Control de energía",
    "tableDisplayInputSwitch": "Conmutación de entrada de pantalla",
    "tableAirConditioning": "Aire acondicionado",
    "tableProjectionScreen": "Pantalla de proyección",
    "tableElectronicLock": "Bloqueo eléctrico",
    "interactiveFlatPanel": "Panel plano interactivo",
    "displayInputSwitch": "Conmutación de entrada de pantalla",
    "speakerVolume": "Volumen de audio",
    "MICVolume": "Volumen MIC",
    "ProjectionScreen": "Pantalla de proyección",
    "ElectronicLock": "Bloqueo eléctrico",
    "AirConditioning": "Aire acondicionado",
    "AirConditioningPower": "Energía",
    "AirConditioningModel": "Modelo",
    "AirConditioningTEMP": "Temperatura",
    "AirConditioningFanSpeed": "Velocidad del ventilador",
    "OPEN": "ABRIR",
    "CLOSE": "CERRAR",
    "UP": "ARRIBA",
    "DOWN": "ABAJO",
    "PowerOFF": "APAGADO",
    "PowerON": "ENCENDIDO",
    "ModelAuto": "Automático",
    "ModelCool": "Frío",
    "ModelHeat": "Calor",
    "ModelAir": "Lado del aire",
    "TEMPLow": "Bajo",
    "TEMPMiddle": "Medio",
    "TEMPHigh": "Alto",
    "btnSave": "Guardar",
    "btnNext": "SIGUIENTE",
    "StartTime": "Hora de inicio",
    "StopTime": "Hora de finalización",
    "Mandatory": "Obligatorio",
    "Video": "Video y Audio",
    "Notification": "Notificación",
    "btnFile": "Seleccionar un archivo multimedia",
    "LastingTime": "Duración",
    "textTitle": "Título",
    "textContent": "Contenido",
    "textTitleLetters": "Menos de 60 letras",
    "textContentLetters": "Menos de 320 letras",
    "CannotquitYES": "SÍ",
    "CannotquitNo": "No",
    "YES": "¿Está seguro de que desea eliminar este programador?",
    "No": "El programador eliminado se moverá a la lista de historial y podrá restaurarse",
    "delTitleContent": "¿Eliminar el programador?",
    "delTitleListContent": "Eliminar el programador causará que las tareas asociadas se borren, por favor confirme.",
    "deleListTitle": "¿Está seguro de que desea eliminar este programador?",
    "delTitleListContent1": "¿Eliminar?",
    "deleListTitle1": "Confirmar",
    "delTitle": "TODO",
    "btnConfirm": "Transmisión",
    "coxAll": "Control del dispositivo",
    "coxBroadcasting": "SÍ",
    "coxDeviveControl": "NO",
    "rdMandatory": "Fecha de inicio",
    "noRdMandatory": "Fecha de finalización",
    "startDate": "-",
    "endedDate": "Tipo",
    "or": "Elegir hora",
    "broadcastingType": "Elegir fecha",
    "ChooseTime": "Nuevo programador",
    "ChooseDate": "Editar programador",
    "newScheduleList": "Nombre",
    "editScheduleList": "Período de validez",
    "listName": "Descripción",
    "listValidityPeriod": "Cancelar",
    "listDescription": "Confirmar",
    "cancel": "Cancelar",
    "confirm": "Confirmar",
    "save": "Guardar",
    "addSuccess": "¡Agregado exitosamente!",
    "addError": "¡Fallo al agregar!",
    "editSuccess": "¡Editado exitosamente!",
    "editError": "¡Fallo al editar!",
    "delSuccess": "¡Eliminado exitosamente!",
    "delError": "¡Fallo al eliminar!",
    "restoreSuccess": "Lista de programación restaurada con éxito",
    "restoreError": "Recuperación de la lista de programación fallida",
    "restoreTitleContent": "Este horario entra en conflicto con el horario en la lista, por favor seleccione de nuevo",
    "Enabled": "Habilitado",
    "Paused": "Pausado",
    "Title": "Título:",
    "Content": "Contenido:",
    "errorScheduleNameRequired": "El nombre de la tarea debe ser completado",
    "errorDeviceRequired": "Por favor seleccione el dispositivo de destino",
    "deleTitle": "¿Está seguro de que desea eliminar esta tarea?",
    "loopList": "Lista de bucles",
    "errorPleaseDateRange": "Por favor seleccione un rango de fechas",
    "addError_2009": "Nombre de programador duplicado",
    "conflicts": "El horario de la tarea entra en conflicto con el siguiente:",
    "Pleaseagain": "Por favor ingrese nuevamente",
    "errorScheduleName": "Nombre de la tarea",
    "errorListName": "Nombre del programador",
    "today": "Hoy",
    "yesterday": "Ayer",
    "thisWeek": "Esta semana",
    "lastWeek": "La semana pasada",
    "lastMonth": "El mes pasado",
    "thisMonth": "Este mes",
    "times": "Veces",
    "TimeConflicts": "Conflictos de tiempo",
    "editError_2006": "Dispositivo no encontrado",
    "editError_2010": "Nombre de tarea duplicado",
    "editError_2100": "La tarea ha expirado, no se puede iniciar.",
    "ListTimeExpired": "El horario del programador ha expirado, por favor seleccione de nuevo",
    "TimeExpired": "Tiempo expirado",
    "ControlOption": "Falta la opción de control",
    "Pleaseleastone": "Por favor seleccione al menos una opción de control",
    "Enter": "Entrar",
    "TitleFilled": "El título debe ser completado",
    "ContentFilled": "El contenido debe ser completado",
    "PleaseMediaFile": "Por favor seleccione un archivo multimedia",
    "PleaseSchedule": "Por favor seleccione una tarea",
    "delTitleScheduleContent": "La tarea eliminada no puede ser recuperada.",
    "deleTitleSchedule": "¿Está seguro de que desea eliminar esta tarea?",
    "deleteScheduleTitle": "Por favor seleccione la tarea a eliminar",
    "PleaseFillColumn": "Por favor complete el nombre del programador",
    "PleaseDate": "Por favor seleccione la fecha",
    "Previous": "Anterior",
    "RemoteControl": "Control remoto",
    "taskhasexpired": "Esta tarea ha expirado, por favor contacte al creador para actualizar el tiempo.",
    "execute": "Ejecutar",
    "broadcastingList": "Lista de difusión",
    "volumeSuccess": "Volumen configurado exitosamente",
    "volumeFailed": "Fallo al configurar el volumen"
  },
  "live": {
    "StreamingRoom": "Sala de streaming",
    "btnAddNewRoom": "Agregar nueva sala",
    "Steaming": "en vivo",
    "Creater": "anfitrión:",
    "Address": "Dirección RTMP:",
    "StreamingURL": "URL de transmisión en vivo:",
    "DestinationNMP": "Seleccionar destino NMP:",
    "stop": "DETENER",
    "stat": "INICIAR",
    "btnCope": "Haga clic para COPIAR",
    "QRcode": "Código QR",
    "Refresh": "Actualizar",
    "AddNewRoomTitle": "Agregar nueva sala de streaming",
    "editNewRoomTitle": "Editar sala de streaming",
    "roomName": "Nombre de la sala:",
    "cancel": "Cancelar",
    "confirm": "Confirmar",
    "save": "Guardar",
    "delTitleContent": "¿Está seguro de que desea eliminar este horario?",
    "delTitle": "¿Eliminar?",
    "delCancelButton": "Cancelar",
    "delConfirmButton": "Confirmar",
    "addSuccess": "¡Agregado con éxito!",
    "addError": "¡Error al agregar!",
    "editSuccess": "¡Editado con éxito!",
    "editError": "¡Error al editar!",
    "delSuccess": "¡Eliminado con éxito!",
    "delError": "¡Error al eliminar!",
    "Stopstreaming": "Detener streaming",
    "Startstreaming": "Iniciar streaming",
    "error2504": "No se pudo obtener la dirección de streaming en vivo del servidor multimedia",
    "error2505": "Nombre de sala de streaming duplicado",
    "error2506": "El dispositivo ha sido ocupado por otra señal de streaming",
    "error1900": "El parámetro accedido está vacío",
    "error2503": "No se pudieron obtener los datos del servidor multimedia",
    "error2507": "Dirección de streaming en vivo duplicada",
    "copySuccess": "El contenido ha sido copiado al portapapeles.",
    "copyError": "El navegador no soporta la copia automática",
    "flashControl": "Flash no está instalado o habilitado. Por favor, intente nuevamente después de instalar o habilitar Flash.",
    "liveStreaming": "No se encontró fuente de streaming en vivo.",
    "btnflash": "Instalar/Habilitar",
    "serverAddress": "Dirección del servidor",
    "addressKey": "Clave:",
    "watchingAddress": "Dirección de visualización",
    "audioOnly": "Solo audio",
    "enterTheKey": "La clave debe ser completada."
  },
  "guidepages": {
    "next": "Próximo dispositivo de control",
    "next1": "Próximo intentar controlar",
    "next2": "Próximo transmisión",
    "next3": "Próximo iniciar transmisión",
    "next4": "Próximo detener transmisión",
    "next5": "Próximo transmisión de texto",
    "next6": "Próximo configuración de tarea",
    "next7": "Próximo agregar nueva tarea",
    "next8": "Próximo lista de historial",
    "next9": "Próximo almacenamiento en la nube",
    "next10": "Próximo transmisión en vivo",
    "next11": "Próximo configurar transmisión en vivo",
    "exit": "Salir",
    "guideContent": "Contenido de la guía",
    "btnHomepage": "Página principal",
    "btnDevices": "Dispositivos",
    "btnBroadcast": "Transmisión",
    "btnSchedule": "Programación",
    "btnResources": "Recursos",
    "btnStreaming": "En vivo",
    "btnPrevious": "Anterior"
  },
  "privacy": {
    "PrivacyPolicy": "Q-NEX Privacy Policy",
    "Byusing": "By using the Q-NEX service, you are trusting us to process your information. We understand that this responsibility is important, so we have been committed to protecting your information and giving you control.",
    "whatinformation": "This Privacy Policy is designed to help you understand what information we collect, why it is collected, and how you manage your information.",
    "EffectiveDate": "Effective Date: January 1, 2020",
    "title1": "Q-NEX Respects Your Privacy",
    "title1Respects1": "Returnstar Interactive Technology Group Co.,Ltd. and its sub-brand (collectively “Q-NEX”, “we” or “us”) respect your privacy and understand that the processing and security of your personal data is important to you. Please review the full Privacy Policy below for more complete details on how we collect, use, share, and protect your personal data, as well as the choices you have regarding our use and sharing of your personal data, along with other important considerations.",
    "title1Respects2": "This Privacy Policy explains Q-NEX’s practices regarding the processing (such as the collection, use, storage, copy or disclosure) of your personal data received: (i) through our website https://www.qnextech.com (“Website”), email, and other written or in person communications; (ii) in the context of all our commercial relations with customers, end-users, dealers, distributors, suppliers, contractors, agents or representatives; and (iii) in the normal course of any other potential business relationship. We commit to comply with our obligations under all applicable Privacy and Data Protection Laws, as described below, including but not limited to the Provisions on Protection of Personal Information of Telecommunications and Internet Users, and to respect your rights whenever we are processing your personal data.",
    "title2": "Privacy and Data Protection",
    "title2Respects1": "“Personal Data” means any information that identifies, or can be used to identify, an individual.",
    "title2Respects2": "“Privacy and Data Protection Laws” means any and/or all laws, rules, directives and regulations, on any local, provincial, state, federal or national level within and outside the People's Republic of China, pertaining to data privacy, data security and/or the protection of Personal Data. Among them, laws and regulations outside China include but not limited to: (a) the General Data Protection Regulation (GDPR) and each European Union Member States’ national implementation thereof; (b) the Australian Privacy Act 1988 (Cth) and the Australian Privacy Amendment (Enhancing Privacy Protection Act) (2012); (c) the Belgian Privacy Law of 8 December 1992; (d) the Canadian Personal Information Protection and Electronic Documents Act, SC 2000, c 5 (PIPEDA); (e) the Personal Data Protection Act 2012 of Singapore (PDPA); (f) additional privacy and data protection laws applicable to a data subject’s location; and (g) any successor legislation or regulations applicable thereto.",
    "title3": "When Do We Collect Your Personal Data?",
    "title3Respects1": "Q-NEX may collect your personal data when you communicate with us by phone, e-mail, the Website or otherwise, in the context of:",
    "title3a": "Browsing our Website or visiting our social media sites;",
    "title3b": "Corresponding with Q-NEX;",
    "title3c": "Visiting one of our offices, events or facilities;",
    "title3d": "Registering for and/or participating in our conferences, events, training or other activities;",
    "title3e": "Requesting information, support, service, materials, assistance or other inquiries;",
    "title3f": "Subscribing to a newsletter or other mailing list;",
    "title3g": "Exchanging business cards;",
    "title3h": "Completing Website contact forms, questionnaires, surveys, or contest entry forms or otherwise participating in these activities;",
    "title3i": "Engaging in commercial relationships or other collaboration;",
    "title3j": "Ordering or registering Q-NEX products;",
    "title3k": "Creating or registering an account;",
    "title3l": "Uploading or downloading files;",
    "title3m": "Verification of your identity as a data subject; or",
    "title3n": "Using Q-NEX products that are connected to the Internet, including mobile apps, cloudware, and certain hardware devices.",
    "title4": "Which Types of Personal Data are Processed by Us?",
    "title4Respects1": "Q-NEX may process the following personal data:",
    "title4a": "Name, surname, title, company, email address, phone number (mobile and landline), address, signature and other contact information;",
    "title4b": "IP addresses;",
    "title4c": "Location data;",
    "title4d": "Cookie ID;",
    "title4e": "Language;",
    "title4f": "Personal preferences regarding communications and/or products and services;",
    "title4g": "Financial details (e.g. payment information, bank account number, and credit information);",
    "title4h": "Personal data regarding projects using Q-NEX products and services;",
    "title4i": "Personal data provided in your submissions, responses and feedback;",
    "title4j": "Personal data regarding your interactions with Q-NEX, including your use of the Website and of Q-NEX’s products or services;",
    "title4k": "Social media data, images, photos, and camera footage; and",
    "title4l": "Any other personal data provided by you or by your authorized Q-NEX dealer or service provider.",
    "title4Respects2": "For the avoidance of doubt, Q-NEX does not collect any sensitive personal data, such as racial or ethnic origin; political opinions; religious or philosophical beliefs; genetic characteristics; health information; sexual preferences; information about children; criminal convictions; or biometric data, and we explicitly ask that you not provide us with such data in your responses or feedback to us.",
    "title5": "How Do We Use Your Personal Data?",
    "title5Respects1": "In order to better manage our own business needs and to better communicate with you, we may collect, analyze, use and otherwise process your personal data for the following purposes:",
    "title5a": "To respond to your inquiries, questions and other requests;",
    "title5b": "To optimize and manage the quality and content of our Website, including the ability to personalize and secure your Website experience;",
    "title5c": "To create and maintain your website, customer and product accounts and registrations;",
    "title5d": "To provide you with marketing, advertising, promotions, programs, offers and other opportunities; including newsletters, information on products and services, subscriptions, training, updates and direct marketing, which may be targeted, based on your communication preferences;",
    "title5e": "To conduct customer satisfaction studies, surveys and other market research;",
    "title5f": "To manage our events and activities, and invite you to events;",
    "title5g": "To register visitors to our offices, facilities and events;",
    "title5h": "To create promotional materials, including videos, photos, articles, case studies, newsletters and other materials regarding projects or events;",
    "title5i": "To provide products, services, training, technical support, customer service and other assistance;",
    "title5j": "To manage and perform our agreements and obligations;",
    "title5k": "To respond to and follow up on business leads, opportunities, and contacts;",
    "title5l": "To process payments, orders, invoicing, returns, collection and other requests;",
    "title5m": "To provide pricing, quotations and custom configurations of our products and services;",
    "title5n": "To grant you access to our software, training, technical information and other proprietary content;",
    "title5o": "To evaluate, troubleshoot, analyze and improve the use, functionality, features, and performance of our products, services, training, technical support and customer service;",
    "title5p": "To gather, analyze and maintain configuration and backup data regarding our products and services;",
    "title5q": "To facilitate planning, analytics, forecasting and reporting regarding our products and services;",
    "title5r": "To use for our internal business operations and processes, including business and financial recordkeeping, data management and business continuity; and",
    "title5s": "To meet our legal and regulatory obligations.",
    "title6": "Which Legal Basis Applies To Our Processing Of Your Personal Data?",
    "title6Respects1": "The following legal grounds might apply to the processing of your personal data for the purposes mentioned above:",
    "title6a": "Processing is necessary for the performance of your agreement with us or in order to take all pre-contractual steps;",
    "title6b": "Processing takes place based upon our legitimate interest (comply with obligations, maintain business records, fraud prevention, network and information security, etc.). When carrying out this type of processing, we strive to strike a balance between this legitimate interest and respect for your privacy;",
    "title6c": "You have given your consent to the processing (e.g. in case of direct marketing, for the processing of analytic cookies and for data transfers to third parties);",
    "title6d": "In order to comply with our legal obligations (such as tax administration and record retention); or",
    "title6e": "In very exceptional circumstances to protect your vital interest or that of someone else.",
    "titel7": "To Whom Do We Disclose Your Personal Data?",
    "title7Respects1": "Q-NEX may disclose your personal data to yourself, to Q-NEX’s affiliates or to third parties, such as payment providers, software providers, cloud partners, transport partners, financial institutions, insurance companies, legal services, or certain other service providers or partners that Q-NEX has a strategic relationship with, in order to fulfill our relationship with you in the most effective way.",
    "title7Respects2": "Q-NEX will not disclose to third parties any personal data you submit for purposes other than those described in this Privacy Policy. If, in the future, we intend to disclose your personal data to third parties for any purpose other than those described in this Privacy Policy we shall inform you thereof in advance and ask your consent if required.",
    "title7Respects3": "Notwithstanding the foregoing, Q-NEX will disclose your personal data to a third party (such as competent authorities) if required to do so by law, during a legal proceeding, or if, in good faith, Q-NEX believes that such action is necessary to comply with certain laws, rules or regulations.",
    "titel8": "Which Guarantees Do We Provide in Case of International Data Transfers?",
    "title8Respects1": "Q-NEX is a global company and we may transfer your information to Q-NEX affiliates, representatives or third party contractors who represent us worldwide. Each affiliate, representative, or third party contractor works closely with Q-NEX, and any transfer of personal data between these associated entities will comply with applicable Privacy and Data Protection Laws.",
    "title8Respects2": "If any transfer of the personal data of residents of the European Economic Area (EEA) is made to a person or entity located in a country outside of the EEA, that is not recognized as providing an adequate level of protection, we will provide for increased information security and appropriate contractual provisions to strengthen data protection. To ensure that any such transfers of the personal data of EEA residents are compliant with the applicable Privacy and Data Protection Laws, we will either (i) conclude a data transfer agreement, based upon the EU model agreements, (ii) adopt binding corporate rules, (iii) rely on legally determined exceptions (such as requesting your explicit consent) or (iv) adopt other mechanisms which have been deemed to provide for the adequate protection of your personal data.",
    "titel9": "How Do We Secure Your Personal Data?",
    "title9Respects1": "We use a variety of security technologies and precautions, such as the Secure Socket Layer (SSL) protocol (encryption), to help protect your personal data from loss, theft, misuse and unauthorized access, in accordance with industry standards. To protect any personal data stored on Q-NEX servers or cloud-based storage, we regularly monitor our systems for vulnerabilities or attacks, and implement up to date information security measures.",
    "title9Respects2": "Access to personal data that is processed by Q-NEX is limited only to those of its employees, contractors and affiliated organizations that need to know that information in order to process it on Q-NEX’s behalf, in accordance with this Privacy Policy, and that have agreed not to disclose it to others.",
    "titel10": "How Long Do We Retain Your Personal Data?",
    "title10Respects1": "Unless a longer retention period is required by law, Q-NEX will retain your personal data for as long as needed to fulfil the relevant purposes described in this Privacy Policy.",
    "titel11": "Use of Cookies",
    "title11Respects1": "Q-NEX uses cookies on our Website, both to enable the site to work properly, and to enhance your experience while visiting our Website. Cookie file(s), which are stored on the hard drive of your computer, enable us to obtain information about your usage of our Website, and to measure and improve the performance of our Website. Cookies enable you to store your preferences, in order to enable our Website to recognize these preferences when you browse our Website.",
    "title11Respects2": "You may refuse to accept cookies by activating the setting on your browser which allows you to refuse cookies. However, if you select this setting you may not be able to access certain sections or features of our Website. Unless you have adjusted your browser setting so that it will refuse cookies, our system will issue cookies to your computer whenever you log on to our Website.",
    "title11Respects3": "When you visit our Website for the first time you will be provided with a link to this cookie policy and will have the opportunity to change your browser settings to refuse cookies. By continuing to browse our website without changing your settings, you agree to our use of cookies as explained in this policy.",
    "title11Respects4GoogleAnalytics": "Google Analytics.",
    "title11Respects4": "We use industry standard web analytics to track visits to our sites, namely those provided by Google Analytics. The information generated by the cookies about your use of our Website (including your IP address) will be transmitted to and stored by Google Analytics on their servers and is handled in accordance with Google’s Privacy Policy which can be accessed at the following link: https://policies.google.com/privacy.",
    "titel12": "Third Party Links on our Website",
    "title12Respects1": "The Website contains links to other websites. Q-NEX is not responsible for the privacy policy of other websites, or the manner in which they store, use or distribute information. Q-NEX encourages you to review the privacy policy of any website you may visit.",
    "titel13": "Children’s Information",
    "title13Respects1": "Q-NEX’s Website is not intended for use by children, and its products and services are not sold to children. In accordance with the Children’s Online Privacy Protection Act, we do not collect or maintain information from persons we know are under 18, and no part of the Website is designed to attract anyone under age 18.",
    "titel14": "What Are Your Rights and How Can You Exercise Them?",
    "title14Respects1": "If you are a natural person, you have the right at all times to be informed about the personal data we process about you, and to the extent authorized under the applicable Privacy and Data Protection Laws, to request access, modification, limitation of processing, transfer or deletion of personal data, or to object to the processing of your personal data, subject to the exceptions within the applicable Privacy and Data Protection Laws.",
    "title14Respects2": "If processing is based solely on your consent, you also have the right to revoke your consent at any time, without prejudice to the lawfulness of processing prior to revocation.",
    "title14Respects3": "Through the contact options listed below, you can exercise the above rights regarding the processing of your personal data by Q-NEX, except in cases where this would require a disproportionate effort on the part of Q-NEX.",
    "title14Respects4": "Please feel free to use the contact information listed below if you have any additional concerns regarding your personal data or your exercise of the above rights, and we will do our best to assist you.",
    "title14Respects5": "If you contact us to exercise one of your rights under the applicable Privacy and Data Protection Laws, we will reply within one (1) month. In certain exceptional circumstances, we may take up to three (3) months to fully respond to you, but in such case we shall inform you why we require additional time to respond in our initial reply.",
    "title14Respects6": "If we are unable to resolve an inquiry or request, where applicable, you may have the right to lodge a complaint with the local data protection authority.",
    "titel15": "Stay Informed of Changes in Our Privacy Policy",
    "title15Respects1": "In a world in which technology and legislation is constantly changing, this Privacy Policy may also change. We invite you to always consult the latest version of this policy, posted at https://www.qnextech.com/legal, and we will inform you of any changes via our Website or other common communication channels.",
    "titel16": "Contact Q-NEX",
    "title16Respects1": "If you have questions and/or comments about this Privacy Policy or the manner in which Q-NEX collects, uses and/or processes your personal data, please contact us:",
    "title16Respects2": "Via e-mail: info@qnextech.com"
    }
}



// WEBPACK FOOTER //
// ./src/lang/es.js